<template>
  <div class="hepatitis-box">
    <span class="title">乙肝自测</span>
    <a-form :form="form" @reset="handleReset" @submit="handleSubmit">
      <a-form-item label="乙肝表面抗原(HBsAg)：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-radio-group v-decorator="['HBsAg',{rules:[{required: true, message: '请选择!'}]}]">
          <a-radio value="-">阴性（-）</a-radio>
          <a-radio value="+">阳性（+）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="乙肝表面抗体(HBsAb)：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-radio-group v-decorator="['HBsAb',{rules:[{required: true, message: '请选择!'}]}]">
          <a-radio value="-">阴性（-）</a-radio>
          <a-radio value="+">阳性（+）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="乙肝E抗原(HBeAg)：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-radio-group v-decorator="['HBeAg',{rules:[{required: true, message: '请选择!'}]}]">
          <a-radio value="-">阴性（-）</a-radio>
          <a-radio value="+">阳性（+）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="乙肝E抗体(HBeAb)：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-radio-group v-decorator="['HBeAb',{rules:[{required: true, message: '请选择!'}]}]">
          <a-radio value="-">阴性（-）</a-radio>
          <a-radio value="+">阳性（+）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="乙肝核心抗体(HBcAb)：" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-radio-group v-decorator="['HBcAb',{rules:[{required: true, message: '请选择!'}]}]">
          <a-radio value="-">阴性（-）</a-radio>
          <a-radio value="+">阳性（+）</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3 }">
        <a-button type="primary" html-type="submit">
          查看结果
        </a-button>
        <a-button html-type="reset" @click="handleReset" style="margin-left: 20px">
          我要重做
        </a-button>
      </a-form-item>
    </a-form>
    <div class="result-box" v-if="result.content">
      <span class="result-text">测试结果</span>
      <div class="result">{{ result.content }}</div>
      <div class="desc" v-if="result.desc">另：俗称，<span>{{ result.desc }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this, {}),
      result: {
        content: undefined,
        desc: undefined
      }
    };
  },

  methods: {
    /** 提交查看结果 */
    handleSubmit() {
      this.form.validateFields((error, values) => {
        if (error === null) {
          let checked = values['HBsAg'] + values['HBsAb'] + values['HBeAg'] + values['HBeAb'] + values['HBcAb'];
          this.handleChecked(checked);
        }
      })
    },

    /** 处理选择的数据 */
    handleChecked(checked) {
      switch (checked) {
        case '-----':
          this.result.content = '过去和现在未感染过HBV，建议注射乙肝疫苗。';
          this.result.desc = '乙肝两对半全阴';
          break;
        case '----+':
          this.result.content = '有以下三种可能性：\n 1.既往感染未能测出抗-HBs；\n 2.恢复期HBsAg已消，抗-HBs尚未出现；\n3.无症状HBsAg携带者。';
          this.result.desc = '乙肝两对半5阳性';
          break;
        case '---++':
          this.result.content = '有以下三种可能性：\n 1.既往感染过HBV；\n 2.急性HBV感染恢复期；\n3.少数标本仍有传染性。';
          this.result.desc = '乙肝两对半45阳性';
          break;
        case '-+---':
          this.result.content = '有以下三种可能性：\n 1.注射过乙肝苗有免疫；\n 2.既往感染；\n3.假阳性。';
          this.result.desc = '乙肝两对半2阳性';
          break;
        case '-+-++':
          this.result.content = '急性HBV感后康复。';
          this.result.desc = '乙肝两对半245阳性';
          break;
        case '+---+':
          this.result.content = '有以下三种可能性：\n1.急性HBV感染；\n2.慢性HBsAg携带者；\n3.传染性弱。';
          this.result.desc = '乙肝两对半15阳性';
          break;
        case '-+--+':
          this.result.content = '有以下两种可能性：\n1.既往感染，仍有免疫力。\n2.HBV感染，恢复期。';
          this.result.desc = '乙肝两对半25阳性';
          break;
        case '+--++':
          this.result.content = '有以下三种可能性：\n1.急性HBV感染趋向恢复；\n2.慢性HBsAg携带者；\n3.传染性相对较弱。';
          this.result.desc = '乙肝两对半145阳性；即俗称的“小三阳”';
          break;
        case '+-+-+':
          this.result.content = '急性或慢性乙肝感染。提示HBV复制，传染强。';
          this.result.desc = '乙肝两对半135阳性，俗称“大三阳”';
          break;
        case '+----':
          this.result.content = '有以下两种可能性：\n1.急性HBV感染早期,急性HBV感染潜伏期；\n2.慢性HBV携带者，传染性弱。';
          this.result.desc = '乙肝两对半1阳性';
          break;
        case '+--+-':
          this.result.content = '有以下两种可能性：\n1.慢性HBsAg携带者易转阴；\n2.急性HBV感染趋向恢复。';
          this.result.desc = '乙肝两对半14阳性';
          break;
        case '+-+--':
          this.result.content = '急性HBV感染早期或慢性携带者，传染性强。';
          this.result.desc = '乙肝两对半13阳性';
          break;
        case '+-+++':
          this.result.content = '有以下两种可能性：\n1.急性HBV感染趋向恢复；\n2.慢性携带者。';
          this.result.desc = '乙肝两对半1345阳性';
          break;
        case '++---':
          this.result.content = '有以下两种可能性：\n1.亚临床型HBV感染早期；\n2.不同亚型HBV二次感染。';
          this.result.desc = '乙肝两对半12阳性';
          break;
        case '++--+':
          this.result.content = '有以下两种可能性：\n1.亚临床型HBV感染早期；\n2.不同亚型HBV二次感染。';
          this.result.desc = '乙肝两对半125阳性';
          break;
        case '++-+-':
          this.result.content = '亚临床型或非典型性感染。';
          this.result.desc = '乙肝两对半124阳性';
          break;
        case '++-++':
          this.result.content = '亚临床型或非典型性感染。';
          break;
        case '+++-+':
          this.result.content = '亚临床型或非典型性感染早期。\nHBsAg免疫复合物，新的不同亚型感染。';
          break;
        case '--+--':
          this.result.content = '有以下三种可能性：\n1.非典型性急性感染；\n2.见于抗-HBc出现之前的感染早期；\n3.HBsAg滴度低而呈阴性，或呈假阳性。';
          this.result.desc = '乙肝两对半3阳性';
          break;
        case '--+-+':
          this.result.content = '非典型性急性感染。';
          break;
        case '--+++':
          this.result.content = '急性HBV感染中期。';
          break;
        case '-+-+-':
          this.result.content = 'HBV感染后已恢复。';
          break;
        case '-++--':
          this.result.content = '非典型性或亚临床型HBV感染。';
          break;
        case '-++-+':
          this.result.content = '非典型性或亚临床型HBV感染。';
          break;
        case '---+-':
          this.result.content = '急性HBV感染趋向恢复。';
          break;
        default:
          this.result.content = ' 输入结果和临床研究不符，请查证您的化验结果再次输入。';
          break;
      }
    },

    /** 重置 */
    handleReset() {
      this.form.resetFields();
      this.result.content = undefined;
      this.result.desc = undefined;
    }
  },
};
</script>

<style lang="less" scoped>
.hepatitis-box {
  padding-left: 15px;

  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    display: inline-block;
  }

  .result-box {
    margin-top: 20px;

    .result-text {
      font-size: 16px;
      font-weight: bold;
    }

    .result {
      margin: 10px;
      line-height: 30px;
      white-space: pre-line;
    }

    .desc {
      margin: 10px;
      font-size: 14px;
      color: #999;

      span {
        color: #ff6600;
        font-weight: bold;
      }
    }
  }
}
</style>